/** Same-tab listeners (storage event only fires in other tabs). */
export const CALLS_ID_SESSION_CHANGED = 'callsId-session-changed';

export const CALLS_ID_SESSION_KEY = 'callsId';

/** Original inbound call ID; preserved when an outbound callback overwrites callsId. */
export const CALLS_ID_INBOUND_SESSION_KEY = 'callsId_inbound';

export function notifyCallsIdSessionChanged(): void {
  window.dispatchEvent(new CustomEvent(CALLS_ID_SESSION_CHANGED));
}

/** Inbound-only: store alongside callsId when the active leg is an incoming call. */
export function setInboundCallsId(callId: string | number): void {
  sessionStorage.setItem(CALLS_ID_INBOUND_SESSION_KEY, String(callId));
}

/** Apply call ID from calls/search; sets callsId_inbound when direction is inbound. */
export function applyCallIdFromSearchResult(call: {
  id: number;
  direction?: string;
}): void {
  const callId = String(call.id);
  sessionStorage.setItem(CALLS_ID_SESSION_KEY, callId);
  if (call.direction === 'inbound') {
    setInboundCallsId(callId);
  }
  notifyCallsIdSessionChanged();
}

/** Active Air Call leg only (never callsId_inbound). Use for pause/resume. */
export function getActiveCallsId(): string | null {
  const callId = sessionStorage.getItem(CALLS_ID_SESSION_KEY);
  if (callId == null || callId === '' || callId === 'undefined') {
    return null;
  }
  return callId;
}

/** Prefer inbound call ID for tagging after an outbound callback replaced callsId. */
export function getCallIdForTagging(): string | null {
  const inbound = sessionStorage.getItem(CALLS_ID_INBOUND_SESSION_KEY);
  if (inbound != null && inbound !== '' && inbound !== 'undefined') {
    return inbound;
  }
  const callId = sessionStorage.getItem(CALLS_ID_SESSION_KEY);
  if (callId == null || callId === '' || callId === 'undefined') {
    return null;
  }
  return callId;
}

export function clearInboundCallsId(): void {
  sessionStorage.removeItem(CALLS_ID_INBOUND_SESSION_KEY);
  notifyCallsIdSessionChanged();
}

/** Clears only the active call ID (outbound / current leg). */
export function clearCallsId(): void {
  sessionStorage.removeItem(CALLS_ID_SESSION_KEY);
  notifyCallsIdSessionChanged();
}

/** Clears both call IDs (e.g. when entering WaitingPage). */
export function clearAllCallIdsSession(): void {
  sessionStorage.removeItem(CALLS_ID_SESSION_KEY);
  sessionStorage.removeItem(CALLS_ID_INBOUND_SESSION_KEY);
  notifyCallsIdSessionChanged();
}

export const AIRCALL_USER_ID_SESSION_KEY = 'aircallUserId';

export const AIRCALL_USER_ID_SESSION_CHANGED = 'aircall-user-id-session-changed';

export function notifyAircallUserIdSessionChanged(): void {
  window.dispatchEvent(new CustomEvent(AIRCALL_USER_ID_SESSION_CHANGED));
}
